export default "__VITE_ASSET__BgJG$19E__"